import { v4 as uuidv4 } from "uuid";
import { NotFoundPlugin } from "../../../../components/pluginSettings";
import { InventorySvedPluginSettings, InventorySvedPluginView } from "..";



export const InventorySvedGridTab = (): ITab => {
    return {
        id: uuidv4(),
        title: "Сводные инвентаризации",
        view: {
            content: InventorySvedPluginSettings 
            ? <InventorySvedPluginView 
                gridId={uuidv4()} 
                plugin={InventorySvedPluginSettings}
            />
            : <NotFoundPlugin />,
        },
    };
};